import clsx from 'clsx';
import {ReactNode} from 'react';

type SectionProps = {
  title?: string;
  subtitle?: string;
  footer?: ReactNode;
  children?: ReactNode;
  headerProps?: React.ComponentProps<'div'>;
  bodyProps?: React.ComponentProps<'div'>;
  footerProps?: React.ComponentProps<'div'>;
} & React.ComponentProps<'div'>;

const Section = (props: SectionProps) => {
  const {
    title,
    subtitle,
    footer,
    children,
    className,
    headerProps,
    bodyProps,
    footerProps,
    ...rest
  } = props;
  return (
    <div
      className={clsx(
        'relative p-4 bg-white rounded-lg border-solid border-gray-300/70 border dark:bg-gray-800 sm:p-5',
        className,
      )}
      {...rest}>
      {/* header */}
      {title && (
        <div
          {...headerProps}
          className={clsx('pb-4 mb-4 rounded-t border-b', headerProps?.className)}>
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white">{title}</h3>
          <h5 className="text-xs">{subtitle}</h5>
        </div>
      )}
      {/* body */}
      <div
        {...bodyProps}
        className={clsx(
          'flex flex-col gap-2',
          {'pb-4 mb-4 border-b': Boolean(footer)},
          bodyProps?.className,
        )}>
        {children}
      </div>
      {/* footer */}
      {footer && (
        <div
          {...footerProps}
          className={clsx('flex items-center space-x-4', footerProps?.className)}>
          {footer}
        </div>
      )}
    </div>
  );
};

export default Section;
